function generateRandomString(length) {
	let result = '';

	const alphanumericChars =
		'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

	for (let i = 0; i < length; i++) {
		const randomIndex = Math.floor(Math.random() * alphanumericChars.length);
		result += alphanumericChars.charAt(randomIndex);
	}

	return result;
}

// Exemplo de uso para gerar uma string aleatória de 8 caracteres
// const randomString = generateRandomString(8);
